import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { OrganizationalUnitList } from "./OrganizationalUnitList";

export const OrganizationalUnitPage: FC = () => {
	return (
		<Routes>
			<Route index element={<OrganizationalUnitList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
